import { useMemo, useState } from 'react';

import { GlobalFiltersState } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

interface Props {
    globalFilters: GlobalFiltersState;
}
export interface FilterOption {
    [key: string]: { label: string; isSelected: boolean };
}

export const SelectedFiltersOptions: FilterOption = {
    milestoneFragnet: { label: 'Activity Fragnet', isSelected: false },
    activityForwardFragnet: { label: 'Activity Forward Fragnet', isSelected: false },
    baselineStartDate: { label: 'Baseline Start Date', isSelected: false },
    baselineFinishDate: { label: 'Baseline Finish Date', isSelected: false },
    cardType: { label: 'Card Type', isSelected: false },
    cluster: { label: 'Cluster', isSelected: false },
    completionPlanSegment: { label: 'Completion Plan Segment', isSelected: false },
    duration: { label: 'Duration', isSelected: false },
    float: { label: 'Float', isSelected: false },
    hasAttachments: { label: 'Has Attachments', isSelected: false },
    hasComments: { label: 'Has Comments', isSelected: false },
    lagLead: { label: 'Lag/Lead', isSelected: false },
    relatedActivity: { label: 'Related Activity', isSelected: false },
    resourceName: { label: 'Resource Name', isSelected: false },
    resourceType: { label: 'Resource Type', isSelected: false },
    startDate: { label: 'Start Date', isSelected: false },
    submittedCompletion: { label: 'Submitted Completion', isSelected: false },
    trackedActivity: { label: 'Tracked Activity', isSelected: false },
    updatedBy: { label: 'Updated By', isSelected: false },
    wbsLevel: { label: 'WBS Level', isSelected: false },
};

const hasFilterValue = (value: unknown): boolean => {
    if (value === undefined) {
        return false;
    }
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return true;
};

const getInitialDropdownOptions = (dropdownFiltersKeys: string[]): FilterOption => {
    return dropdownFiltersKeys.reduce<FilterOption>((acc, key) => {
        if (SelectedFiltersOptions[key]) {
            acc[key] = { ...SelectedFiltersOptions[key] };
        }
        return acc;
    }, {});
};

export const useGetDropdownOptions = ({ globalFilters }: Props) => {
    const initialDropdownFiltersOptions = useMemo(() => {
        const filtersKeys = Object.keys(globalFilters);
        const defaultDropdownOptions = getInitialDropdownOptions(filtersKeys);

        return Object.keys(defaultDropdownOptions).reduce<FilterOption>((acc, key) => {
            const defaultDropdownOption = defaultDropdownOptions[key];
            const filterValue = globalFilters[key];
            acc[key] = hasFilterValue(filterValue)
                ? { ...defaultDropdownOption, isSelected: true }
                : { ...defaultDropdownOption };
            return acc;
        }, {});
    }, [globalFilters]);

    const [dropdownFiltersOptions, setDropdownFiltersOptions] = useState<FilterOption>(initialDropdownFiltersOptions);

    return {
        dropdownFiltersOptions,
        setDropdownFiltersOptions,
    };
};
